export default function middleware(...midds) {
  const chain = [...midds];
  const runner = (...args) => {
    let pos = 0;
    let context = {};
    let result = undefined;
    const getFlowHandler = () => {
      let lock = false;
      return {
        context,
        next: () => {
          if (!lock) {
            lock = true;
            pos += 1;
            nextMidd(pos);
          }
        },
        end: (res) => {
          if (!lock) {
            lock = true;
            result = res;
          }
        }
      }
    };
    const nextMidd = (pos) => {
      try {
        if (pos < chain.length) {
          const midd = chain[pos];
          midd(getFlowHandler(), ...args);
        }
      } catch (e) {
        throw new Error(`Error running middleware in pos ${pos}. Error: ${e}`);
      }
    };
    nextMidd(pos);
    return result;
  };
  runner.use = fn => {
    if (fn && typeof fn === 'function') {
      chain.push(fn);
    }
  };
  return runner;
}
